<template>
  <div class="form-group" :class="{ 'has-error': errors.has(validationName) }">
    <label class="control-label" v-if="label" v-html="label" />
    <vue-editor
      :name="name"
      v-model="content"
      :data-vv-name="name"
      :editorToolbar="editorToolbar"
      :editorOptions="editorOptions"
      :disabled="disabled"
      :class="maxHeight === 248 ? 'quill-container-smaller' : '' || maxHeight === 282 ? 'quill-container-bigger' : ''"
      class="editor-class"
      ref="editor"
    />
    <error-message :message="errors.first(validationName)"></error-message>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";

export default {
  name: "form-group-quill-editor",
  inject: ["$validator"],
  props: {
    label: String,
    data: {
      default: "",
      type: String
    },
    name: {
      default: "",
      type: String
    },
    scope: {
      type: String,
      default: ""
    },
    editorToolbar: {
      default: () => [
        ["bold", "italic", "underline", "strike"],
        ["blockquote", "code-block"],
        [{ header: 1 }, { header: 2 }],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ script: "sub" }, { script: "super" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ direction: "rtl" }],
        [{ size: ["small", false, "large", "huge"] }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ color: [] }, { background: [] }],
        [{ font: [] }],
        [{ align: [] }],
        ["clean"],
        ["link", "image", "video"],
        ["formula"]
      ],
      type: Array
    },
    editorOptions: {
      default: { placeholder: "Escreva seu texto aqui!" },
      type: Object
    },
    disabled: {
      default: false,
      type: Boolean
    },
    maxHeight: Number
  },
  components: {
    "vue-editor": VueEditor
  },
  data() {
    return {
      content: "",
      awaitingChange: false,
      recentChange: false
    };
  },
  computed: {
    validationName() {
      return this.scope ? `${this.scope}.${this.name}` : this.name;
    }
  },
  watch: {
    content: {
      handler(value, oldValue) {
        this.$emit("update:data", value);
      },
      deep: true
    },
  },
  mounted() {
    this.content = this.data;
  },
};
</script>

<style>
.quillWrapper {
  margin-bottom: 15px;
}

.ql-editor {
  font-family: "Roboto", sans-serif !important;
  font-size: 14px !important;
}

.ql-container.ql-snow {
  border-radius: 0 0 3px 3px;
  -moz-border-radius: 0 0 3px 3px;
  -webkit-border-radius: 0 0 3px 3px;
}

.ql-snow.ql-toolbar {
  border-radius: 3px 3px 0 0;
  -moz-border-radius: 3px 3px 0 0;
  -webkit-border-radius: 3px 3px 0 0;
}

.form-group.has-error .ql-snow {
  border-color: #a94442 !important;
}

#quill-container.ql-container.ql-snow {
  overflow: hidden;
}

.quill-container-smaller #quill-container.ql-container.ql-snow {
  max-height: 248px;
}

.quill-container-bigger #quill-container.ql-container.ql-snow {
  height: 282px;
}

.editor-class {
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Forms/QuillEditor.vue